import React from "react"

export const GlassCup = (props) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_13148_77135"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="15"
      >
        <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13148_77135)">
        <path
          // eslint-disable-next-line max-len
          d="M7.00293 1.08594C8.33473 1.08601 9.44545 1.54322 10.335 2.45703C11.1987 3.34452 11.6421 4.44274 11.667 5.75195H12.25L11.083 12.8828C11.0539 13.1841 10.9305 13.4325 10.7119 13.627C10.5217 13.7961 10.2996 13.8911 10.0469 13.9131L10.0479 13.9189H3.95215V13.9131C3.69978 13.8909 3.4781 13.7959 3.28809 13.627C3.06949 13.4325 2.94615 13.1841 2.91699 12.8828L1.75 5.75195H2.33789C2.3628 4.44282 2.80625 3.34449 3.66992 2.45703C4.55951 1.54314 5.67098 1.08594 7.00293 1.08594ZM7.00293 2.25293C5.99187 2.25293 5.15524 2.59493 4.49414 3.28027C3.85802 3.93978 3.52893 4.76391 3.50488 5.75195H10.501C10.4769 4.7639 10.1469 3.93978 9.51074 3.28027C8.84974 2.59511 8.01376 2.253 7.00293 2.25293Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default GlassCup
